/* eslint-disable @typescript-eslint/naming-convention */
export enum Role {
  /**
   * Administrateur de Tiime Business
   * @type {Role.BUSINESS_ADMIN}
   */
  BUSINESS_ADMIN = 'ROLE_BUSINESS_ADMIN',
  /**
   * Comptable qui utilise Tiime Expert
   *
   * À appliquer en parallèle de {@link Role.ACCOUNTANT} en attendant la migration côté back
   * @type {Role.PARTNER_ACCOUNTANT}
   */
  PARTNER_ACCOUNTANT = 'ROLE_PARTNER_ACCOUNTANT',
  /**
   * Comptable qui utilise Tiime Expert
   *
   * À appliquer en parallèle de {@link Role.PARTNER_ACCOUNTANT} en attendant la migration côté back
   * @type {Role.ACCOUNTANT}
   */
  ACCOUNTANT = 'ROLE_ACCOUNTANT',
  /**
   * Personne qui paramètre les outils d’amélioration de la donnée
   * @type {Role.DATA_MANAGER}
   */
  DATA_MANAGER = 'ROLE_DATA_MANAGER',
  /**
   * Personne qui paramèrtre les outils d’amélioration de la donnée
   * @type {Role.ENGINE_ADMIN}
   */
  ENGINE_ADMIN = 'ROLE_ENGINE_ADMIN',
  /**
   * Administrateur de Partner qui utilise Tiime Expert
   * @type {Role.PARTNER_ADMIN}
   */
  PARTNER_ADMIN = 'ROLE_PARTNER_ADMIN',
  /**
   * Invité qui a un accès restreint
   *
   * À appliquer en parallèle de {@link Role.GUEST} en attendant la migration côté back
   * @type {Role.PARTNER_GUEST}
   */
  PARTNER_GUEST = 'ROLE_PARTNER_GUEST',
  /**
   * Invité qui a un accès restreint
   *
   * À appliquer en parallèle de {@link Role.PARTNER_GUEST} en attendant la migration côté back
   * @type {Role.GUEST}
   */
  GUEST = 'ROLE_GUEST',
  /**
   * Commercial d’un Partner
   * @type {Role.PARTNER_SALES}
   */
  PARTNER_SALES = 'ROLE_PARTNER_SALES',
  /**
   * Testeur de l'assistant tiime
   * @type {Role.EXPERT_ASSISTANT_TESTER}
   */
  EXPERT_ASSISTANT_TESTER = 'ROLE_EXPERT_ASSISTANT_TESTER'
}
